import MeridiaBadge from 'src/design_system/components/badge/MeridiaBadge.vue';
import MeridiaButton from 'src/design_system/components/button/MeridiaButton.vue';
import MeridiaCheckbox from 'src/design_system/components/checkbox/MeridiaCheckbox.vue';
import MeridiaChip from 'src/design_system/components/chip/MeridiaChip.vue';
import MeridiaFlag from 'src/design_system/components/flag/MeridiaFlag.vue';
import MeridiaInput from 'src/design_system/components/input/MeridiaInput.vue';
import MeridiaRadioButton from 'src/design_system/components/radioButton/MeridiaRadioButton.vue';
import MeridiaSingleSelect from 'src/design_system/components/select/singleSelect/MeridiaSingleSelect.vue';
import MeridiaMultipleSelect from 'src/design_system/components/select/multipleSelect/MeridiaMultipleSelect.vue';
import MeridiaColumn from 'src/design_system/components/table/column/MeridiaColumn.vue';
import MeridiaTable from 'src/design_system/components/table/table/MeridiaTable.vue';
import MeridiaTag from 'src/design_system/components/tag/MeridiaTag.vue';
import MeridiaDropdownButton from 'src/design_system/components/button/dropdownButton/MeridiaDropdownButton.vue';
import MeridiaSplitButton from 'src/design_system/components/button/splitButton/MeridiaSplitButton.vue';
import MeridiaDatePicker from 'src/design_system/components/datePicker/MeridiaDatePicker.vue';
import MeridiaTextArea from 'src/design_system/components/textArea/MeridiaTextArea.vue';
import MeridiaFileUpload from 'src/design_system/components/fileUpload/MeridiaFileUpload.vue';
import MeridiaPaginator from 'src/design_system/components/paginator/MeridiaPaginator.vue';
import MeridiaIcon from 'src/design_system/components/icon/MeridiaIcon.vue';
import MeridiaMeterGroup from 'src/design_system/components/meterGroup/MeridiaMeterGroup.vue';
import MeridiaMessage from 'src/design_system/components/message/MeridiaMessage.vue';
import MeridiaToastContainer from 'src/design_system/services/toast/MeridiaToastContainer.vue';
import MeridiaDialog from 'src/design_system/components/dialog/MeridiaDialog.vue';
import MeridiaSlider from 'src/design_system/components/slider/MeridiaSlider.vue';
import MeridiaPopover from 'src/design_system/components/popover/MeridiaPopover.vue';
import MeridiaAutocomplete from 'src/design_system/components/autocomplete/MeridiaAutocomplete.vue';
import MeridiaToggle from 'src/design_system/components/toggle/MeridiaToggle.vue';

export function initComponentLibrary(app: any): void {
  app.component('MeridiaBadge', MeridiaBadge);
  app.component('MeridiaButton', MeridiaButton);
  app.component('MeridiaCheckbox', MeridiaCheckbox);
  app.component('MeridiaChip', MeridiaChip);
  app.component('MeridiaFlag', MeridiaFlag);
  app.component('MeridiaInput', MeridiaInput);
  app.component('MeridiaRadioButton', MeridiaRadioButton);
  app.component('MeridiaSingleSelect', MeridiaSingleSelect);
  app.component('MeridiaMultipleSelect', MeridiaMultipleSelect);
  app.component('MeridiaColumn', MeridiaColumn);
  app.component('MeridiaTable', MeridiaTable);
  app.component('MeridiaTag', MeridiaTag);
  app.component('MeridiaDropdownButton', MeridiaDropdownButton);
  app.component('MeridiaSplitButton', MeridiaSplitButton);
  app.component('MeridiaDatePicker', MeridiaDatePicker);
  app.component('MeridiaTextArea', MeridiaTextArea);
  app.component('MeridiaFileUpload', MeridiaFileUpload);
  app.component('MeridiaPaginator', MeridiaPaginator);
  app.component('MeridiaIcon', MeridiaIcon);
  app.component('MeridiaMeterGroup', MeridiaMeterGroup);
  app.component('MeridiaMessage', MeridiaMessage);
  app.component('MeridiaToastContainer', MeridiaToastContainer);
  app.component('MeridiaDialog', MeridiaDialog);
  app.component('MeridiaSlider', MeridiaSlider);
  app.component('MeridiaPopover', MeridiaPopover);
  app.component('MeridiaAutocomplete', MeridiaAutocomplete);
  app.component('MeridiaToggle', MeridiaToggle);
}

// TypeScript declaration for global components
declare module 'vue' {
  export interface GlobalComponents {
    MeridiaBadge: typeof MeridiaBadge;
    MeridiaButton: typeof MeridiaButton;
    MeridiaCheckbox: typeof MeridiaCheckbox;
    MeridiaChip: typeof MeridiaChip;
    MeridiaFlag: typeof MeridiaFlag;
    MeridiaInput: typeof MeridiaInput;
    MeridiaRadioButton: typeof MeridiaRadioButton;
    MeridiaSingleSelect: typeof MeridiaSingleSelect;
    MeridiaMultipleSelect: typeof MeridiaMultipleSelect;
    MeridiaColumn: typeof MeridiaColumn;
    MeridiaTable: typeof MeridiaTable;
    MeridiaTag: typeof MeridiaTag;
    MeridiaDropdownButton: typeof MeridiaDropdownButton;
    MeridiaSplitButton: typeof MeridiaSplitButton;
    MeridiaDatePicker: typeof MeridiaDatePicker;
    MeridiaTextArea: typeof MeridiaTextArea;
    MeridiaFileUpload: typeof MeridiaFileUpload;
    MeridiaPaginator: typeof MeridiaPaginator;
    MeridiaIcon: typeof MeridiaIcon;
    MeridiaMeterGroup: typeof MeridiaMeterGroup;
    MeridiaMessage: typeof MeridiaMessage;
    MeridiaToastContainer: typeof MeridiaToastContainer;
    MeridiaDialog: typeof MeridiaDialog;
    MeridiaSlider: typeof MeridiaSlider;
    MeridiaPopover: typeof MeridiaPopover;
    MeridiaAutocomplete: typeof MeridiaAutocomplete;
    MeridiaToggle: typeof MeridiaToggle;
  }
}
